export default [
  
  {
  "readingcompTitle": "Streaming Fatigue: Too Much of a Good Thing?",
  "topic": "streaming",
  "level": "b2",
  "image": "/Images/streamingfatigue1.webp",
  "vocabulary": [
    "streaming - online tartalom közvetítése",
    "fatigue - fáradtság, kimerültség",
    "overload - túlterheltség",
    "subscription - előfizetés",
    "binge - egyhuzamban sokat nézni/hallgatni",
    "content - tartalom",
    "decision-making - döntéshozatal",
    "cancel - lemondani",
    "curated - gondosan válogatott",
    "engaged - elkötelezett, figyelmes"
  ],
  "paragraphs": [
    {
      "text": [
        "<p>Streaming services have changed how we watch TV shows, movies, and listen to music. With platforms like Netflix and Spotify, we can enjoy content anytime, anywhere. But with so much choice, some people are feeling tired of it all. This is called <strong>streaming fatigue</strong>.</p>",
        "<p>Streaming fatigue happens when people feel overwhelmed by too many options. They spend more time browsing than watching or listening. Some even feel pressure to keep up with popular shows, which makes entertainment feel like work.</p>",
        "<p>There is also <strong>subscription fatigue</strong>. Many users now pay for multiple services, and managing them all can be confusing and expensive. As a result, some people are starting to cancel their subscriptions or take breaks.</p>",
        "<p>To fix this, some companies are offering <strong>curated</strong> content—smaller selections based on personal tastes. Music apps use playlists and recommendations to reduce decision-making stress and keep users <strong>engaged</strong>.</p>",
        "<p>Experts say the best way to avoid streaming fatigue is to take breaks, limit screen time, and only watch or listen when you truly want to—not just because everyone else is doing it.</p>"
      ],
      "questions": [
        {
          "number": "1",
          "question": "What is 'streaming fatigue'?",
          "choices": [
            "A. Getting bored of old movies",
            "B. Feeling tired from watching too many ads",
            "C. Being overwhelmed by too much content",
            "D. Having no access to streaming services"
          ]
        },
        {
          "number": "2",
          "question": "Why do some users cancel subscriptions?",
          "choices": [
            "A. They don't like TV shows anymore",
            "B. They forget their passwords",
            "C. They feel there are too few options",
            "D. They are tired of paying for many services"
          ]
        },
        {
          "number": "3",
          "question": "What does 'curated content' mean?",
          "choices": [
            "A. Content chosen randomly",
            "B. Ads shown on free platforms",
            "C. A limited selection based on user interests",
            "D. Only music and no videos"
          ]
        },
        {
          "number": "4",
          "question": "How do music apps help reduce decision stress?",
          "choices": [
            "A. By limiting access to music",
            "B. By offering free movies",
            "C. With playlists and smart suggestions",
            "D. By removing popular songs"
          ]
        },
        {
          "number": "5",
          "question": "What is one suggested way to avoid streaming fatigue?",
          "choices": [
            "A. Watch as many shows as possible",
            "B. Subscribe to every service",
            "C. Take breaks and limit screen time",
            "D. Follow every trending show"
          ]
        }
      ]
    }
  ]
}
]
